<template>
  <!-- 个人中心 -->
  <div class="mine">
    <div class="contain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Personalcenter",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.mine {
  background: #f7f7f7;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .contain {
    width: 80%;
    max-width: 1600px;
    margin: 0 auto;
    overflow: auto;
  }
}
@media screen and (max-width: 640px) {
  .mine {
    .contain {
      width: 100%;
    }
  }
}
@media screen and (min-width: 1200px) {
  .mine {
    .contain {
      width: 80%;
      max-width: 1600px;
    }
  }
}
</style>
